import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { pageHTML } from "../shared/pages.js";

var root = $.from_html(`<button type="button" class="like svelte-ozz4sr"> </button>`);
var root_1 = $.from_html(`<div class="holder svelte-ozz4sr"><!> <!></div>`);

const $$css = {
	hash: 'svelte-ozz4sr',
	code: '.holder.svelte-ozz4sr {position:absolute;inset:0;}.holder.svelte-ozz4sr .page {height:100%;}.like.svelte-ozz4sr {position:absolute;top:12px;right:12px;font:inherit;cursor:pointer;border:1px solid #d6cfbd;background:#fffdf8;border-radius:999px;padding:2px 10px;}'
};

export default function Page($$anchor, $$props) {
	$.push($$props, true);
	$.append_styles($$anchor, $$css);

	// Kept through a turn: the component is moved, never mounted twice.
	let likes = $.state(0);

	var div = root_1();
	var node = $.child(div);

	$.html(node, () => pageHTML($$props.page));

	var node_1 = $.sibling(node, 2);

	{
		var consequent = ($$anchor) => {
			var button = root();
			var text = $.only_child(button);

			$.template_effect(() => $.set_text(text, `♥ ${$.get(likes) ?? ''}`));
			$.delegated('click', button, () => $.set(likes, $.get(likes) + 1));
			$.append($$anchor, button);
		};

		$.if(node_1, ($$render) => {
			if ($$props.page.kind === "front") $$render(consequent);
		});
	}

	$.reset(div);
	$.append($$anchor, div);
	$.pop();
}

$.delegate(['click']);